import { Factory } from 'miragejs'

export default Factory.extend({
  preferences() {
    return {
      teacher_home_enabled: false,
      widgets: ['program-links', 'upcoming-assignments', 'quick-actions', 'recent-activity'],
    }
  },
})
